module.exports = __webpack_public_path__ + "static/media/kv-th.53fee1b9.jpg";